import React, { useState, useEffect } from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import { Observer } from 'mobx-react';
import {
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  FormControl,
  FormControlLabel,
  Button,
} from '@material-ui/core';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { css } from '@emotion/core';
import { useParams, useHistory } from 'react-router-dom';
import { useTabContext } from '@material-ui/lab';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import { WideBox, FormRow } from '../../styles/styles';
import Spinner from '../../util/Spinner';
import SimpleSelect from '../../util/SimpleSelect';
import RenderPropModal from '../../dealMapper/common/RenderPropModal';
import SaveTemplate from './SaveTemplate';
import DealFilters from './DealFilters';
import DealTranFilters from './DealTranFilters';
import DealTranAccFilters from './DealTranAccFilters';
import { safeEval } from '../../util/UtilFunctions';

const FormStyle = css`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  margin: 1rem 0px;
`;

const PivotTableContainer = css`
  display: flex;
  flex: 1;
  width: 100%;
  .pvtOutput {
    width: 100% !important;
  }
`;

const FilterContainer = css`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  width: 100%;
`;

const ButtonRow = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  button {
    margin-right: 5px;
  }
`;

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
}));

const capitalize = ([first, ...rest]) => first.toUpperCase() + rest.join('');

const getRelevantTableData = ({
  cols,
  rows,
  vals,
  sorters,
  valueFilter,
  rowOrder,
  colOrder,
  tableOptions,
  aggregatorName,
}) => ({
  cols,
  rows,
  vals,
  sorters,
  valueFilter,
  rowOrder,
  colOrder,
  tableOptions,
  aggregatorName,
});

const iFilterValues = {
  startDate: '',
  endDate: '',
  transactionCategories: [],
};

const Report = () => {
  const history = useHistory();
  const { reportID, reportType: passedReportType } = useParams();
  const { dataStore, authStore, orgStore } = useRootStore();
  const [containerLoading, setContainerLoading] = useState(true);
  const [reportTemplate, setReportTemplate] = useState(null);
  const [initialValues, setInitialValues] = useState(iFilterValues);
  const [tableState, setTableState] = useState(null);

  const { dashboardConfig } = orgStore;

  const getReportTemplate = async id => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/report-template/${id}`,
      );
      const { TemplateData, TemplateFilters } = data;
      setReportTemplate(data);
      setInitialValues(TemplateFilters);
      setTableState(TemplateData);
    } catch (e) {
      console.error(e);
    }
  };

  // const updateDashboardPref = async ({ TemplateId, Name }) => {
  //   const clonePref = [...dashboardConfig];
  //   const pIndex = dashboardConfig.findIndex(x => x.Name === 'Reports'); // index of Reports in preferences
  //   const cloneVisRep = [...clonePref[pIndex].VisibleReports];
  //   // index of specific template within VisibileReports Array
  //   const prefIndex = cloneVisRep.findIndex(
  //     item => item.TemplateId === TemplateId,
  //   );
  //   if (prefIndex > -1 && !dashPref) {
  //     cloneVisRep.splice(prefIndex, 1);
  //     clonePref[pIndex].VisibleReports = cloneVisRep;
  //   } else if (prefIndex === -1 && dashPref) {
  //     cloneVisRep.push({ TemplateId, Name });
  //     clonePref[pIndex].VisibleReports = cloneVisRep;
  //   }

  //   const payload = JSON.stringify(clonePref);
  //   try {
  //     await authStore.request.post(`${process.env.REACT_APP_API}/api/config`, {
  //       dashboardConfig: payload,
  //     });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  useEffect(() => {
    const initialize = async () => {
      const requests = [];
      if (reportID) {
        requests.push(getReportTemplate(reportID));
        console.log(toJS(dashboardConfig));
        // const pIndex = dashboardConfig.findIndex(x => x.Name === 'Reports');
        // // FIXME: Need a new strategy for showing reports
        // const prefIndex = dashboardConfig[pIndex].VisibleReports.findIndex(
        //   item => item.TemplateId === reportID,
        // );
        // prefIndex > -1 ? setDashPref(true) : setDashPref(false);
      }
      await Promise.all(requests);
      setContainerLoading(false);
    };
    initialize();
  }, [reportID]);

  // TODO report type

  if (containerLoading) return <Spinner />;

  const reportType =
    safeEval(() => capitalize(passedReportType), null) || reportTemplate.Type;
  return (
    <Formik
      initialValues={initialValues}
      render={({
        values,
        handleBlur,
        handleChange,
        setFieldValue,
        dirty,
        resetForm,
      }) => (
        <Observer
          render={() => {
            const classes = useStyles();
            const [isLoading, setLoading] = useState(true);
            const [tableDeals, setTableDeals] = useState([]);
            const transactionCategories =
              dataStore.validTransactionCategoryArray;

            const updateAllData = newData => {
              setTableDeals(newData);
              if (tableState) {
                const tState = { ...tableState };
                tState.data = newData;
                setTableState(tState);
              }
            };

            const getDealReport = async (passedValues = values) => {
              try {
                const { data } = await authStore.request.get(
                  `${process.env.REACT_APP_API}/api/deal-report`,
                  {
                    params: {
                      StartDate: passedValues.startDate || null,
                      EndDate: passedValues.endDate || null,
                      CategoryIds: passedValues.transactionCategories,
                    },
                  },
                );
                updateAllData(data);
              } catch (e) {
                console.error(e);
              }
            };

            const getDealTranReport = async (passedValues = values) => {
              try {
                const { data } = await authStore.request.get(
                  `${process.env.REACT_APP_API}/api/deal-tran-report`,
                  {
                    params: {
                      StartDate: passedValues.startDate || null,
                      EndDate: passedValues.endDate || null,
                    },
                  },
                );
                updateAllData(data);
              } catch (e) {
                console.error(e);
              }
            };

            const getDealTranAccReport = async (passedValues = values) => {
              try {
                const { data } = await authStore.request.get(
                  `${process.env.REACT_APP_API}/api/deal-tran-acc-report`,
                  {
                    params: {
                      StartDate: passedValues.startDate || null,
                      EndDate: passedValues.endDate || null,
                    },
                  },
                );
                updateAllData(data);
              } catch (e) {
                console.error(e);
              }
            };

            const getReportByType = {
              Deal: getDealReport,
              DealTran: getDealTranReport,
              DealTranAcc: getDealTranAccReport,
            };
            const getReport = getReportByType[reportType];

            useEffect(() => {
              const initialize = async () => {
                const requests = [];
                if (transactionCategories.length === 0) {
                  requests.push(dataStore.retrieveTransactionCategories());
                }
                if (getReport) {
                  requests.push(getReport());
                } else {
                  history.push('/reports');
                }

                await Promise.all(requests);
                setLoading(false);
              };
              initialize();
            }, []);

            const saveReportTemplate = async ({ Name, UserOnly }) => {
              try {
                const TemplateData = getRelevantTableData(tableState);
                const { data } = await authStore.request.post(
                  `${process.env.REACT_APP_API}/api/report-template`,
                  {
                    Type: reportType,
                    Name,
                    UserId: UserOnly ? null : true,
                    TemplateData: JSON.stringify(TemplateData),
                    TemplateFilters: JSON.stringify(values),
                  },
                );

                const { id } = data;
                setContainerLoading(true);

                history.push(`/report/${id}`);
              } catch (e) {
                console.error(e);
              }
            };

            const updateReportTemplate = async () => {
              try {
                const TemplateData = getRelevantTableData(tableState);
                const { Name, Type, UserId, TemplateId } = reportTemplate;
                const { data } = await authStore.request.post(
                  `${process.env.REACT_APP_API}/api/report-template`,
                  {
                    Type,
                    TemplateId,
                    Name,
                    UserId,
                    TemplateData: JSON.stringify(TemplateData),
                    TemplateFilters: JSON.stringify(values),
                  },
                );
                // updateDashboardPref({ TemplateId, Name });
                // await getReportTemplates();
                // const { id } = data;
                // setSelectedTemplate({ Name, id });
              } catch (e) {
                console.error(e);
              }
            };

            if (isLoading) return <Spinner />;

            const hasChanged = !(values === initialValues);

            const getFilterComponentByType = {
              Deal: DealFilters,
              DealTran: DealTranFilters,
              DealTranAcc: DealTranAccFilters,
            };

            const FilterComponent = getFilterComponentByType[reportType];

            return (
              <WideBox
                showoverflow
                style={{
                  maxWidth: '1500px',
                  width: '98%',
                  alignSelf: 'center',
                }}
              >
                <Typography variant="h2" gutterBottom>
                  {reportTemplate ? reportTemplate.Name : 'Reports'}
                </Typography>

                <div css={FormStyle}>
                  <FilterComponent
                    {...{
                      transactionCategories,
                      values,
                      handleBlur,
                      handleChange,
                      setFieldValue,
                      dirty,
                      resetForm,
                      hasChanged,
                      getReport,
                      initialValues,
                    }}
                  />
                </div>
                <div css={PivotTableContainer}>
                  <PivotTableUI
                    data={tableDeals}
                    onChange={s => setTableState(s)}
                    unusedOrientationCutoff={Infinity}
                    {...tableState}
                  />
                </div>
                <RenderPropModal
                  cardDisplay={({ handleClose }) => (
                    <SaveTemplate
                      saveReportTemplate={saveReportTemplate}
                      handleClose={handleClose}
                    />
                  )}
                >
                  {({ handleOpen }) => (
                    <div css={ButtonRow}>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={handleOpen}
                        disabled={!tableState}
                      >
                        Save As New Template
                      </Button>

                      {reportID && (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={updateReportTemplate}
                          disabled={!tableState}
                        >
                          Update Report Template
                        </Button>
                      )}
                    </div>
                  )}
                </RenderPropModal>
              </WideBox>
            );
          }}
        />
      )}
    />
  );
};

export default Report;

// startDate, endDate, transactionCategoriesID array

// report-template

// report-templates
